import { useState, useEffect } from "react";
import moment from "moment";

import { yellow } from "@mui/material/colors";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import StarIcon from "@mui/icons-material/Star";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import FormControlLabel from "@mui/material/FormControlLabel";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/bundle";

import config from "../config.json";

export default function ProcessedPumps({
	processedFoundPumps,
	processedNotFoundPumps,
	setSearch,
	addFavCoin,
	favIconsArr,
	removeFavCoin,
}) {
	const [query, setQuery] = useState("");
	const [typeToShow, setTypeToShow] = useState("FOUND");

	const [activeItemId, setActiveItemId] = useState(0);
	const [activeItem, setActiveItem] = useState(null);

	const navigateForward = () => {
		const index = processedFoundPumps.findIndex(
			(item) => item.id === activeItem?.id
		);
		if (index === processedFoundPumps.length - 1) return;
		setActiveItem(processedFoundPumps[index + 1]);
	};

	const navigateBack = () => {
		const index = processedFoundPumps.findIndex(
			(item) => item.id === activeItem?.id
		);
		if (index === 0) return;
		setActiveItem(processedFoundPumps[index - 1]);
	};

	useEffect(() => {
		const handleKeyPress = (event) => {
			switch (event.keyCode) {
				case 27: // ESC key
					setActiveItem(null);
					break;
				case 37: // Left arrow key
					navigateBack();
					break;
				case 39: // Right arrow key
					navigateForward();
					break;
				default:
					break;
			}
		};
		window.addEventListener("keydown", handleKeyPress);

		return () => {
			window.removeEventListener("keydown", handleKeyPress);
		};
	}, [navigateBack, navigateForward]);

	const openSwiper = (id) => {
		if (!id) return;
		// setActiveItemId(id);
		const item = processedFoundPumps.find((x) => x.id === id);
		if (!item) return;
		setActiveItem(item);
	};

	const closeSwiper = () => {
		setActiveItem(null);
	};

	const findCurrentItem = () => {
		if (!activeItemId) console.log("o4en ploho");
		const item = processedFoundPumps.find((x) => x.id === activeItemId);
		if (!item) return processedFoundPumps[0];
		return item;
	};
	return (
		<div style={{ display: "flex", flexDirection: "column", flex: "1 1 80%" }}>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					gap: "20px",
				}}
			>
				<h3>Completed</h3>
				<TextField
					id="certain-coin-search"
					value={query}
					onChange={(e) => {
						const newValue = e.target.value;
						setQuery(() => newValue);
						setSearch(newValue, "FOUND");
					}}
					type="text"
					placeholder="Search for a coin"
				/>
				<FormControlLabel
					label="found"
					control={
						<Checkbox
							checked={typeToShow === "FOUND"}
							color="success"
							onChange={(event) => {
								setTypeToShow((oldState) => "FOUND");
							}}
						/>
					}
				/>
				<FormControlLabel
					label="not found"
					control={
						<Checkbox
							color="error"
							checked={typeToShow === "NOT_FOUND"}
							onChange={(event) => {
								setTypeToShow("NOT_FOUND");
							}}
						/>
					}
				/>
			</div>
			{processedNotFoundPumps && processedFoundPumps && (
				<>
					<div
						style={{
							overflowY: "auto",
							display: "flex",
							flexWrap: "wrap",
							gap: "10px",
						}}
					>
						{(() =>
							typeToShow === "FOUND"
								? processedFoundPumps
								: processedNotFoundPumps)().map(
							(
								{ id, symbol, plotResultPath, createdAt, finishDate },
								index
							) => (
								<div
									key={id}
									onClick={() => openSwiper(id)}
									style={{
										width: "200px",
										height: "220px",
										display: "flex",
										position: "relative",
										flexDirection: "column",
										alignItems: "center",
										padding: "2px",
										border: "1px solid black",
										borderRadius: "4px",
										marginBottom: "10px",
									}}
								>
									<IconButton
										size="large"
										onClick={(e) => {
											if (favIconsArr.includes(symbol)) {
												removeFavCoin(symbol);
											} else {
												addFavCoin(symbol);
											}
											e.stopPropagation();
											e.preventDefault();
										}}
										sx={{
											position: "absolute",
											right: "0px",
											top: "70%",
											color: yellow[500],
											transform: "translateY(-70%)",
											background: "transparent",
											border: "none",
											cursor: "pointer",
											fontSize: "20px",
											"&:hover": {
												backgroundColor: "#F2FBE0",
											},
										}}
									>
										{favIconsArr.includes(symbol) ? (
											<StarIcon />
										) : (
											<StarBorderIcon />
										)}
									</IconButton>
									<span
										style={{
											fontSize: "15px",
											width: "90%",
											textAlign: "center",
											padding: "2px",
										}}
									>
										Launched: {moment(+createdAt).format("DD MMM HH:mm")}
									</span>
									{typeToShow === "FOUND" && (
										<img
											loading="lazy"
											style={{
												width: "95%",
												height: "auto",
												objectFit: "contain",
											}}
											src={config.imagesServer + plotResultPath}
											alt={symbol}
										/>
									)}
									<span
										style={{
											width: "90%",
											textAlign: "center",
										}}
									>
										Last scope: {moment(finishDate).format("DD MMM")}
									</span>
									<span
										style={{
											width: "90%",
											textAlign: "center",
										}}
									>
										Coin: {symbol}
									</span>
								</div>
							)
						)}
					</div>
					{!!activeItem && (
						// background div
						<Box
							sx={{
								position: "fixed",
								top: 0,
								left: 0,
								width: "100vw",
								height: "100vh",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								zIndex: 100,
								backgroundColor: "rgba(0, 0, 0, 0.5)",
							}}
						>
							<Box
								sx={{
									position: "relative",
									width: "90%",
									height:
										"90%" /* Adjust modal height to be 80-90% of the viewport height */,
									flexDirection: "column",
									justifyContent: "center" /* Center content vertically */,
									alignItems: "center" /* Center content horizontally */,
									padding: "20px",
									boxSizing:
										"border-box" /* Include padding in the box model */,
									overflow: "hidden",
									// backgroundColor: "yellow",
								}}
							>
								<Button
									variant="contained"
									size="large"
									onClick={navigateBack}
									sx={{
										zIndex: 100,
										position: "absolute",
										top: "50%",
										left: 0,
										transform: "translateY(-50%)",
									}}
								>
									<ArrowBackIosIcon />
								</Button>
								<Button
									variant="contained"
									size="large"
									onClick={navigateForward}
									sx={{
										zIndex: 100,
										position: "absolute",
										top: "50%",
										right: 0,
										transform: "translateY(-50%)",
									}}
								>
									<ArrowForwardIosIcon />
								</Button>
								<IconButton
									size="large"
									onClick={(e) => {
										if (favIconsArr.includes(activeItem.symbol)) {
											removeFavCoin(activeItem.symbol);
										} else {
											addFavCoin(activeItem.symbol);
										}
										e.stopPropagation();
										e.preventDefault();
									}}
									sx={{
										zIndex: 100,
										position: "absolute",
										right: "0px",
										top: "25%",
										color: yellow[500],
										transform: "translateY(-70%)",
										background: "transparent",
										border: "none",
										cursor: "pointer",
										fontSize: "20px",
										"&:hover": {
											backgroundColor: "#F2FBE0",
										},
									}}
								>
									{favIconsArr.includes(activeItem.symbol) ? (
										<StarIcon />
									) : (
										<StarBorderIcon />
									)}
								</IconButton>
								<Box
									sx={{ position: "relative", width: "100%", height: "100%" }}
								>
									<img
										style={{
											maxWidth: "100%", // Ensures image does not exceed the container's width
											maxHeight: "100%", // Ensures image does not exceed the container's height
											objectFit: "contain",
											margin: "auto",
										}}
										src={config.imagesServer + activeItem?.plotResultPath}
										alt={"ana"}
									/>
								</Box>
								<Button
									variant="contained"
									color="error"
									size="large"
									onClick={closeSwiper}
									sx={{
										position: "absolute",
										top: 0,
										right: 0,
									}}
								>
									<CloseIcon />
								</Button>
							</Box>
						</Box>
					)}
				</>
			)}
		</div>
	);
}
